<template>
  <!-- Figma UQ "Equipment Info - Step 1/4": dot+bar title, round reset button (grey until something changes, then red),
       System Type / Make, then Model* / Serial* / Date of Manufacture. The page's Continue pill submits (QuoteEdit). -->
  <div class="uqForm flex flex-col gap-[15px] font-roboto">
    <div class="flex items-center justify-between gap-[10px]">
      <div class="flex items-center gap-1 min-w-0">
        <span class="flex-shrink-0 w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
        <span class="flex-shrink-0 w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
        <h2 class="m-0 pl-2 text-[16px] laptop:text-[18px] font-semibold text-[#333333]">
          Enter or update the equipment information
        </h2>
      </div>
      <button type="button" aria-label="Reset equipment information"
        class="group flex-shrink-0 w-[34px] h-[34px] laptop:w-[40px] laptop:h-[40px] flex justify-center items-center rounded-full border-0 p-0 bg-transparent disabled:bg-[#EFEFEF] disabled:cursor-not-allowed"
        :disabled="!isFormChanged" @click="resetClicked()">
        <img src="../../assets/images/reset-form-icon.png" alt="" class="w-full h-full group-disabled:!hidden">
        <img src="../../assets/images/bx_reset.png" alt="" class="w-[22px] h-[22px] hidden group-disabled:block">
      </button>
    </div>
    <div class="grid grid-cols-1 tablet:grid-cols-2 gap-[10px] tablet:gap-[15px]">
      <div class="flex flex-col gap-[5px]">
        <label class="uqLabel" for="uqEquipType">System Type</label>
        <input id="uqEquipType" v-model="formData.equipment_type" type="text" placeholder="Enter System Type" class="form-control" @keyup="validateField">
      </div>
      <div class="flex flex-col gap-[5px]">
        <label class="uqLabel" for="uqEquipMake">Make</label>
        <input id="uqEquipMake" v-model="formData.equipment_make" type="text" placeholder="Enter Make" class="form-control" @keyup="validateField">
      </div>
    </div>
    <div class="grid grid-cols-1 tablet:grid-cols-3 gap-[10px] tablet:gap-[15px]">
      <div class="flex flex-col gap-[5px]">
        <label class="uqLabel" for="uqEquipModel">Model <span class="text-[#EE5851]">*</span></label>
        <input id="uqEquipModel" v-model="formData.equipment_model" type="text" placeholder="Enter Model" class="form-control" @keyup="validateField">
      </div>
      <div class="flex flex-col gap-[5px]">
        <label class="uqLabel" for="uqEquipSerial">Serial <span class="text-[#EE5851]">*</span></label>
        <input id="uqEquipSerial" v-model="formData.equipment_serial" type="text" placeholder="Enter Serial" :disabled="serialDisable"
          class="form-control" @keyup="validateField">
      </div>
      <div class="flex flex-col gap-[5px]">
        <label class="uqLabel">Date of Manufacture</label>
        <date-picker v-model:value="formData.equipment_manufacture_date" input-class="disable-input"
          format="MM/DD/YYYY" placeholder="MM/DD/YYYY" :confirm="true" :readonly="false" :clearable="false"
          :disabled-date="disabledBefore" value-type="format" @change="validateField">
          <template #icon-calendar>
            <img src="../../assets/images/calender-iconP.svg" alt="" class="w-5 h-5">
          </template>
        </date-picker>
      </div>
    </div>
  </div>
  <div id="equipmentInformation" ref="equipmentInformation" class="modal fade fxModal fxConfirm" data-bs-backdrop="static" tabindex="-1"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
      <div class="modal-content">
        <div class="modal-body">
          <ConfirmLayout title="Equipment Information" button-text="Continue" @close="closeEquipmentInformation()"
            @confirm="continueEquipmentInformation()">
            Are you sure you want to update equipment information?
          </ConfirmLayout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "vue-datepicker-next";
import "vue-datepicker-next/index.css";
import { useToast } from "vue-toastification";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
import { Modal } from "bootstrap";
import ConfirmLayout from "@/components/confirmDialog/ConfirmLayout.vue";
const toast = useToast();

export default {
  components: {
    DatePicker,
    ConfirmLayout,
  },

  data() {
    return {
      serialDisable: false,
      originalFormData: '',
      formData: {
        equipment_type: "",
        equipment_make: "",
        equipment_model: "",
        equipment_serial: "",
        equipment_manufacture_date: "",
      },
    };
  },
  computed: {
    ...mapGetters([
      "setEquipmentInfo",
      "saveEquipmentInfo",
      "quoteDetail",
      "saveEquipmentInfoStore",
    ]),

    isFormChanged() {
      return JSON.stringify(this.formData) !== this.originalFormData;
    }
  },

  watch: {
    saveEquipmentInfo: function () {
      this.setData();
    },

    saveEquipmentInfoStore: function () {
      toast.success("Equipment information updated successfully.");
      this.setCommponent("QuoteItems");
    },
  },

  setUp() { },
  mounted() {
    this.getEquipmentInfoDetail();
  },

  methods: {
    ...mapActions(["getEquipmentInfo", "equipmentInfoStore", "setCommponent"]),

    resetClicked() {
      this.setData();
    },

    validateField() {
      // alert("validate" , this.formData.equipment_manufacture_date)

      if (this.isValid("watcher")) {
        // this.txtSerialDisable = false;
        this.$emit('equipment-info-change', false);
      } else {
        this.$emit('equipment-info-change', true);
        // this.txtSerialDisable = true;
      }
    },

    disabledBefore: function (date) {
      const cdate = new Date();
      cdate.setHours(0, 0, 0, 0);
      return date > cdate;
    },
    setData() {
      let equipmentInfo = {
        equipment_type:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_type ?? "",
        equipment_make:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_make ?? "",
        equipment_model:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_model ?? "",
        equipment_serial:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_serial ?? "",
        equipment_manufacture_date:
          this.$store.state.product.saveEquipmentInfo.equipment_info
            .equipment_manufacture_date ?? "",
      };
      this.serialDisable =
        equipmentInfo.equipment_serial.length <= 0 ? false : true;
      this.formData = equipmentInfo;
      this.originalFormData = JSON.stringify(this.formData);
      this.validateField();
    },

    getEquipmentInfoDetail() {
      this.getEquipmentInfo({
        manual_quote_id: this.quoteDetail.id,
      });
    },

    storeEquipmentInfoClicked() {
      disableScroll()
      this.modal = new Modal(this.$refs.equipmentInformation);
      this.modal.show();
    },
    closeEquipmentInformation() {
      enableScroll()
      this.modal.hide();
    },
    continueEquipmentInformation() {
      this.closeEquipmentInformation();
      if (this.isValid("submit")) {
            this.formData["manual_quote_id"] = this.quoteDetail.id;
            this.equipmentInfoStore(this.formData);
          }
    },

    isValid(action) {
      let status = true;
      let message = "";

      if (this.formData.equipment_type.length <= 0) {
        status = false;
        message = "System Type field is required.";
      } else if (this.formData.equipment_make.length <= 0) {
        status = false;
        message = "Make field is required.";
      } else if (this.formData.equipment_model.length <= 0) {
        status = false;
        message = "Model field is required.";
      }
      // else if (this.formData.equipment_serial.length <= 0) {
      //     status = false
      //     message = 'Serial field is requierd.'
      // }
      else if (this.formData.equipment_manufacture_date.length <= 0) {
        status = false;
      }

      if (!status && action == "submit") {
        toast.error(message);
      }

      return status;
    },
  },
};
</script>
